import  { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../../../redux/hooks";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  message,
} from "antd";
import { callCreatePost } from "../../../../config/api";
import { createPost } from "../../../../types/backend";
import TextFormat from "../../../../components/TextFormat";

const { Option } = Select;

const AddPost = (props: any): JSX.Element => {
  const [open, setOpen] = useState(false);
  const categories = useAppSelector((state) => state.category.result);
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm();

  const showModal = () => {
    setOpen(true);
  };

  const onFinish = async (values: createPost) => {
    setLoading(true)
    const addPost: createPost = {
      ...values,
      likes: [],
    };
    const result = await callCreatePost(addPost);
    if (result.statusCode === 201) {
      setOpen(false);
      props.handleFetchPost();
      message.success("Tạo bài viết thành công !");
    } else {
      message.error("Tạo bài viết thất bại !");
    }
    setLoading(false)
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Spin spinning={loading}>
      <Button type="primary" onClick={showModal} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm bài viết"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="title"
                label="Title"
                rules={[{ required: true, message: "Please enter title" }]}>
                <Input placeholder="Please enter title" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="image"
                label="Image"
                rules={[{ required: true, message: "Please enter title" }]}>
                <Input placeholder="Please enter title" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="categoryId"
                label="Category"
                rules={[
                  { required: true, message: "Please choose the category" },
                ]}>
                <Select placeholder="Please choose the category">
                  {categories.map((item: any) => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <TextFormat />
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default AddPost;
